import { Dispatch, useCallback, useEffect } from "react";
import { AnyAction } from "redux";
import { Socket } from "socket.io-client";

export const useClientQueued = (socket: Socket, dispatch: Dispatch<any>) => {
  const handleSetNewQueuedGroup = useCallback((data) => dispatch({
    ...data, payload: { ...data.payload, groupToUpdate: 'queued' }
  }), [dispatch]) // SOCKET_CLIENT_QUEUED

  useEffect(() => {
    const handler = (data: AnyAction) => { handleSetNewQueuedGroup(data) }

    socket.on('client-queued', handler)
    return () => {
      socket.off('client-queued', handler)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
